import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/embed/')({
  component: EmbedHelpPage,
})

function EmbedHelpPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-stone-50 dark:bg-mist-950 font-sans p-6">
      <div className="max-w-md w-full bg-white dark:bg-mist-900 rounded-2xl shadow-xl p-8 text-center border border-stone-200 dark:border-mist-800">
        <h1 className="text-3xl font-bold mb-4 text-stone-900 dark:text-white">Embedding Slides</h1>
        <p className="text-lg text-stone-600 dark:text-stone-400 mb-8 leading-relaxed">
          Learn how to easily embed your real-time sermon slides into your own website or custom application.
        </p>
        <a 
          href="https://learn.sermon-slides.com/docs/embed" 
          className="inline-flex items-center justify-center w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-lg gap-2"
        >
          View Embed Documentation
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      </div>
    </div>
  )
}
